module.exports = __webpack_public_path__ + "static/media/YM36_1.7b80d965.jpg";